import { render, staticRenderFns } from "./NotificationPermissionAlert.vue?vue&type=template&id=29c077ae"
import script from "./NotificationPermissionAlert.vue?vue&type=script&lang=js"
export * from "./NotificationPermissionAlert.vue?vue&type=script&lang=js"
import style0 from "./NotificationPermissionAlert.vue?vue&type=style&index=0&id=29c077ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports